import type { BoundaryImportKey } from "./flyout/boundary";

/** Stacked screen for drawing the boundary, or an area to import a layer's FOND data from. */
export const BASE_DATA_POLYGON_DRAW_SCREEN = "base-data-polygon-draw";

/** What the polygon drawn on the polygon draw screen is for. */
export type PolygonDrawParams = { purpose: "boundary" } | { purpose: "importArea"; layerKey: BoundaryImportKey };
